<template>
  <!-- Widok filtra typu wykresu (chart type), widoczny tylko jeśli coś jest ustawione -->
  <div v-if="store.filters.graphType" class="filter d-flex flex-column">
    <h5 class="margin-0">
      {{ t('chart-type') }}
      <!-- Ikona do zwijania/rozwijania sekcji (zakomentowana, gotowa na przyszłość) -->
      <!-- <span
        class="icon-collapse"
        data-bs-toggle="collapse"
        href="#graphTypeFilterView"
        role="button"
        aria-expanded="true"
        aria-controls="graphTypeFilterView"
      ></span> -->
      <!-- Ikona kosza do usuwania filtra -->
      <span class="icon-trash" @click="removeFilter()" role="button"></span>
    </h5>
    <!-- Sekcja z opisem aktualnie wybranego typu wykresu -->
    <div class="info collapse show" id="graphTypeFilterView">
      <p v-if="store.filters.graphType" class="margin-0">
        <!-- Wyświetla tekst odpowiadający wybranemu typowi wykresu (np. "Liniowy", "Słupkowy") -->
        {{ store.graphType[store.filters.graphType] }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // Oczekiwany obiekt store z filtrami (wstrzykiwany z rodzica)
    store: { required: true },
  },
  name: "GraphTypeFilterView",
  methods: {
    // Usuwa filtr z głównego store po kliknięciu ikony kosza
    removeFilter() {
      this.store.removeItem("graphType");
    },
  },
};
</script>
<style scoped>
.filter {
  width: 100%;
}

.filter h5 {
  margin: 0;
  padding: var(--spacing-md) var(--spacing-lg);
  position: relative;
  background: var(--surface-secondary);
  border-bottom: 1px solid var(--border-default);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  letter-spacing: var(--letter-spacing-caps);
  text-transform: uppercase;
  color: var(--text-primary);
}
.info {
  font-size: var(--font-size-sm);
  padding: var(--spacing-md) var(--spacing-lg);
  border-bottom: 1px solid var(--border-default);
}
.info p {
  font-size: var(--font-size-sm);
  /* margin: 0; */
}
.icon-trash {
  /* Ikona kosza do usuwania filtra */
  background: url("../../assets/icons/trash.svg") no-repeat left top;
  width: 15px;
  height: 17px;
  position: absolute;
  cursor: pointer;
  top: 8px;
  right: 10px;
}
.icon-collapse {
  /* Ikona zwijania sekcji (jeśli byłaby aktywna) */
  background: url("../../assets/icons/zwin.png") no-repeat left top;
  width: 19px;
  height: 19px;
  position: absolute;
  cursor: pointer;
  right: 20px;
}
.collapsed.icon-collapse {
  background: url("../../assets/icons/rozwin.png") no-repeat left top;
}
</style>
